import DOMPurify from "dompurify";
import { Dayjs } from "dayjs";

export const combineDayJSToUnix = (eventDate: Dayjs, time: Dayjs) => {
  const combinedDate = new Date(
    `${eventDate.format("YYYY-MM-DD")}T${time.format("HH:mm:ss")}`
  );
  return Math.floor(combinedDate.getTime() / 1000);
};

export const unixToDateString = (unixTime: number) => {
  const date = new Date(unixTime * 1000);

  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const addOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return day + "th";
    switch (day % 10) {
      case 1:
        return day + "st";
      case 2:
        return day + "nd";
      case 3:
        return day + "rd";
      default:
        return day + "th";
    }
  };

  const day = addOrdinalSuffix(date.getDate());
  const formattedDate = date.toLocaleDateString("en-US", options);

  return formattedDate.replace(/\d{1,2}/, day);
};

export const unixDateDiff = (d1: number, d2: number) => {
  return d1 - d2;
};

export const getMonthAndDayFromMilliseconds = (time: number) => {
  const date = new Date(time * 1000);
  return date.toLocaleString("default", {
    month: "short",
    day: "numeric",
  });
};

export const getHourFromMilliseconds = (time: number) => {
  var t = new Date(time * 1000).getHours();
  t = t % 12;
  return (t ? t : 12).toString();
};

export const getMinutesFromMilliseconds = (time: number) => {
  const date = new Date(time * 1000);
  let minutes = date.getMinutes();

  minutes = (Math.round(minutes / 15) * 15) % 60;

  return minutes.toString().padStart(2, "0");
};

export const nthNumber = (time: number) => {
  const dT = parseInt(
    new Date(time * 1000).toLocaleString("default", {
      day: "2-digit",
    })
  );
  return ["ST", "ND", "RD"][((((dT + 90) % 100) - 10) % 10) - 1] || "TH";
};

export const unixToHourAndMinutes = (unixTime: number): string => {
  const date = new Date(unixTime * 1000); // Convert unix time to JavaScript time
  let hours = date.getHours();
  let minutes = date.getMinutes().toString();
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes.length === 1 ? "0" + minutes : minutes;
  let strTime = hours + ":" + minutes;
  strTime = strTime.endsWith(":00") ? strTime.slice(0, -3) : strTime; // Remove ':00' from the time if it ends with it
  return strTime;
};

export const getAmOrPm = (unixTime: number): string => {
  const date = new Date(unixTime * 1000); // Convert unix time to JavaScript time
  const hours = date.getHours();
  return hours >= 12 ? "PM" : "AM";
};

export const dateToUnix = (date: Date) => {
  return Math.floor(date.getTime() / 1000);
};

export const toBase64 = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const sanitizeAndPrepareEmailDescription = (content: string) => {
  const sanitizedContent = DOMPurify.sanitize(content);

  const contentWithInlineStyles = sanitizedContent.replace(
    /class="[^"]*\bql-indent-(\d+)\b[^"]*"/g,
    (match, p1) => {
      const indentLevel = parseInt(p1, 10);
      const paddingLeft = indentLevel * 20;
      return `style="padding-left: ${paddingLeft}px; list-style-position: inside;"`;
    }
  );

  const finalContent = contentWithInlineStyles.replace(/ class="[^"]*"/g, "");

  return `<div style="margin: 0;line-height: 1.3;"><style>
          div > p { margin: 0; }
          ul, li, ol { margin-top: 1.3px; margin-bottom: 1.3px; }
          </style>${finalContent}</div>`;
};
